import { Box, InputLabel, Typography, styled } from "@mui/material";
import type { PropsWithChildren } from "react";

interface InputFieldWrapperProps {
  label: string;
  error?: string;
}

const Container = styled(Box)({
  position: "relative",
});

const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.text.primary,
  paddingBottom: "0.25rem",
}));

const ErrorMessage = styled(Typography)(({ theme }) => ({
  position: "absolute",
  fontSize: "0.75rem",
  color: theme.palette.error.main,
}));

export const InputFieldWrapper: React.FC<PropsWithChildren<InputFieldWrapperProps>> = ({
  label,
  error,
  children,
}) => {
  return (
    <Container>
      {Boolean(label) && <StyledInputLabel>{label}</StyledInputLabel>}
      {children}
      {Boolean(error) && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};
